module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-dusty-rose-2-f88cea6a5670fe7be466a2912e39d46d.png";